import { Component, ElementRef, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { fuseAnimations } from '@fuse/animations';
import { CoursesAPIService } from '@shared/services/coursesApi.service';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { CurrentHubService } from '@shared/services/currentHub.service';
import { Learnspace, LearnspaceUserRole } from '@shared/models';
import { CurrentContextService } from '@shared/services/currentContextService';
import { LearnspaceDetailBaseComponent } from '@shared/base-components/learnspace-detail.base.component';
import { AuthenticationService } from '@shared/services/authentication.service';
import { SimulationListComponent } from './simulation-list/simulation-list.component';

@Component({
  selector: 'program-overview',
  templateUrl: './program-overview.component.html',
  styleUrls: ['./program-overview.component.scss'],
  animations: fuseAnimations
})

export class ProgramOverviewComponent extends LearnspaceDetailBaseComponent implements OnChanges {
  @Input() learnspace: Learnspace;
  @ViewChild('fileInput') fileInput: ElementRef<HTMLInputElement>;
  @ViewChild('simulationList') simulationList: SimulationListComponent;

  constructor(
    protected _authservice: AuthenticationService,
    protected _courseApiService: CoursesAPIService,
    protected _CurrentContextService: CurrentContextService,
    protected _dialog: MatDialog,
    protected _route: ActivatedRoute,
    protected _authService: AuthenticationService,
    protected _router: Router,
    protected _currentHubService: CurrentHubService
  ) {
    super(_authservice, _courseApiService, _CurrentContextService, _dialog, _route, _authService, _router, _currentHubService);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.learnspace) {
      this.setup(this.learnspace);
    }
  }

  get canEditSimulations(): boolean {
    return this.learnspace?.lsRole === LearnspaceUserRole.contributor;
  }

  public onImportFileSelected(event: any): void {
    const file: File = event.target.files[0];
    event.target.value = '';
    if (!file) { return; }

    const formData = new FormData();
    formData.append('file', file);
    this._courseApiService.importCourse(this.learnspace.id, formData).subscribe(() => {
      this.simulationList?.loadCourses();
    });
  }
  isAdmin(): boolean {
    return this._authservice.isAdmin();
  }
}
